import React from 'react';

export const SkeletonProduct: React.FC = () => {
    return (
        <>
            <div className="relative block h-[309px] w-[256px] animate-pulse bg-neutral-500/10"></div>
        </>
    );
};
